import { render, staticRenderFns } from "./ProductInfo.vue?vue&type=template&id=14849e4a&scoped=true"
import script from "./ProductInfo.vue?vue&type=script&lang=js"
export * from "./ProductInfo.vue?vue&type=script&lang=js"
import style0 from "./ProductInfo.vue?vue&type=style&index=0&id=14849e4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14849e4a",
  null
  
)

export default component.exports